import { manageCatgoryConstants } from "./constants/manageCategoryConstants";

const manageCategoryGetByFilter = (data: any) => {
	return {
		type: manageCatgoryConstants.ManageCategoryGetByfilterRequest,
		input: data,
	};
};

const manageCategoryUpdateStatus = (data: any) => {
	return {
		type: manageCatgoryConstants.ManageCategoryUpdateStatusRequest,
		input: data,
	};
};

const manageCategoryCreate = (data: any) => {
	return {
		type: manageCatgoryConstants.ManageCategoryCreateRequest,
		input: data,
	};
};

const manageCategoryUpdate = (data: any) => {
	return {
		type: manageCatgoryConstants.ManageCategoryUpdateRequest,
		input: data,
	};
};

const manageCategoryDelete = (id: any) => {
	return {
		type: manageCatgoryConstants.ManageCategoryDeleteRequest,
		input: id
	};

};

export const ManageCategoryAction = {
	manageCategoryGetByFilter,
    manageCategoryUpdateStatus,
    manageCategoryCreate,
	manageCategoryUpdate,
	manageCategoryDelete
};
